import * as React from 'react';
import { ThemeProvider } from 'telia-front-react';
const TeliaThemeProvider = (props) => {
    const getIconPath = (name) => {
        const req = require.context('@telia-front/icon/lib/svg/', false, /^\.\/icons.svg$/);
        return req(req.keys()[0]) + name;
    };
    return (React.createElement(ThemeProvider, { getIconPath: getIconPath, portalRoot: document.getElementById('telia-header') }, props.children));
};
export default TeliaThemeProvider;
//# sourceMappingURL=TeliaThemeProvider.js.map